// setMeData.js
'use strict';
import isEqual from 'lodash/isEqual';
import { SET_ME_DATA } from '../ActionTypes.js';

const avaliableFields = [
  'accountLinks',
  'paymentMethods',
  'notificationAsker',
  'billingProfile',
  'bankInfo',
];

/**
 * Set me data
 * @kind action
 * @param {object} payload - action payload
 * @param {array|string} payload.selectPath - select path
 * @param {any} payload.value - value
 * @return {Promise} Action promise.
 */
const setMeData =
  ({ selectPath, value }) =>
  async dispatch => {
    const isAvaliable = avaliableFields.some(field =>
      isEqual(field, selectPath)
    );
    if (isAvaliable) {
      return dispatch({
        type: SET_ME_DATA,
        payload: {
          selectPath,
          value,
        },
      });
    }

    return {
      type: '',
    };
  };

export default setMeData;
